var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{ref:"image",attrs:{"data-src":_vm.data.lazyload || _vm.skipLoad ? _vm.src : null,"src":!_vm.data.lazyload && !_vm.skipLoad ? _vm.src : '',"alt":_vm.defaultImage.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }